import { FC, ReactElement } from 'react';

import { GoForwardButtonBase } from '../shared/GoForwardButtonBase';

interface Props {
  addBackButton?: boolean;
  onForwardClick?: () => void;
  mobileText?: string;
  disabled?: boolean;
  desktopText?: string;
  Icon?: FC;
  className?: string;
  tipo?: 'button' | 'reset' | 'submit';
}

export function GoForwardButton({
  addBackButton = false,
  onForwardClick,
  disabled = false,
  mobileText = 'Avançar',
  desktopText = 'Continuar',
  Icon,
  className,
  tipo = 'button',
}: Props): ReactElement {
  return (
    <GoForwardButtonBase
      addBackButton={addBackButton}
      onForwardClick={onForwardClick}
      disabled={disabled}
      mobileText={mobileText}
      desktopText={desktopText}
      Icon={Icon}
      type={tipo}
      buttonClassName={`max-[748px]:max-w-[262px] max-[748px]:w-full ${
        className ?? ''
      }`}
    />
  );
}
